<script>
import NumericRangeSelector from '@/components/org/NumericRangeSelector'
import PickerSelector from '@/components/org/PickerSelector'
import DateSelector from '@/components/org/DateSelector'
import MatchSignupContestantConfig from '@/tbs/model/vo/MatchSignupContestantConfig'

const matchSignupContestantConfig = new MatchSignupContestantConfig

export default {
    //--------------------------------------------------
	// component name
	//--------------------------------------------------
	name: 'org-match-signup-contestant-config-edit',

    //--------------------------------------------------
	// component components
	//--------------------------------------------------
    components: {
        'numeric-range-selector': NumericRangeSelector,
        'picker-selector': PickerSelector,
        'date-selector': DateSelector,
    },

    //--------------------------------------------------
    // component emits
    //--------------------------------------------------
	emits: ['custom-event'],

    //--------------------------------------------------
    // component data
    //--------------------------------------------------
    data() {
        return {
            matchGroup: {
                id: null,
                teamNumMin: null,
                teamNumMax: null,
                genderRestriction: null,
                maleNumMin: null,
                maleNumMax: null,
                femaleNumMin: null,
                femaleNumMax: null,
                ageBirthMin: null,
                ageBirthMax: null,
                numSelection: null,
            },
            locale: {}
        }
    },

    //--------------------------------------------------
    // computed setter and getter
    //--------------------------------------------------
    computed: {
        teamNumDownField() {
            // console.log('teamNumDownField', this.matchGroup.teamNumMin || Number(this.matchGroup.numSelection))
            return this.matchGroup.teamNumMin || Number(this.matchGroup.numSelection)
        },
        genderRestrictionOptions() {
            return matchSignupContestantConfig.genderRestrictionTypeOptions
        },
        isGenderNumShow() {
            return this.matchGroup.genderRestriction == '4'
        },
        minDateField() {
            const currentYear = (new Date).getFullYear()
            return new Date(currentYear - 51, 0, 1)
        },
        maxDateField() {
            // const currentYear = (new Date).getFullYear()
            // return new Date(currentYear + 51, 0, 1)
            return new Date
        },
    },

    //--------------------------------------------------
    // component methods
    //--------------------------------------------------
    methods: {
        onSaveBtnClick() {
            this.$emit('custom-event', {
                type: 'save',
                data: this.matchGroup
            })
        },
        onTeamNumDataChange: function(data) {
            console.log('onTeamNumDataChange', data)
            if (data.min == this.matchGroup.teamNumMin 
                && data.max == this.matchGroup.teamNumMax) {
                return
            }
            this.matchGroup.teamNumMin = data.min
            this.matchGroup.teamNumMax = data.max
            if (this.matchGroup.maleNumMax > this.matchGroup.teamNumMax) {
                this.matchGroup.maleNumMax = this.matchGroup.teamNumMax
            }
            if (this.matchGroup.femaleNumMax > this.matchGroup.teamNumMax) {
                this.matchGroup.femaleNumMax = this.matchGroup.teamNumMax
            }
            this.submitData()
        },
        onGenderRestrictionDataChange: function(data) {
            console.log('onGenderRestrictionDataChange', data)
            if (data.value == this.matchGroup.genderRestriction) {
                return
            }
            this.matchGroup.genderRestriction = data.value
            this.submitData()
        },
        onMaleNumDataChange: function(data) {
            console.log('onMaleNumDataChange', data)
            if (data.min == this.matchGroup.maleNumMin 
                && data.max == this.matchGroup.maleNumMax) {
                return
            }
            this.matchGroup.maleNumMin = data.min
            this.matchGroup.maleNumMax = data.max
            this.submitData()
        },
        onFemaleNumDataChange: function(data) {
            console.log('onFemaleNumDataChange', data)
            if (data.min == this.matchGroup.femaleNumMin 
                && data.max == this.matchGroup.femaleNumMax) {
                return
            }
            this.matchGroup.femaleNumMin = data.min
            this.matchGroup.femaleNumMax = data.max
            this.submitData()
        },
        onAgeRestrictionMinDateChange: function(data) {
            console.log('onAgeRestrictionMinDateChange', data)
            if (data == this.matchGroup.ageBirthMin) {
                return
            }
            this.matchGroup.ageBirthMin = data
            this.submitData()
        },
        onAgeRestrictionMaxDateChange: function(data) {
            console.log('onAgeRestrictionMaxDateChange', data)
            if (data == this.matchGroup.ageBirthMax) {
                return
            }
            this.matchGroup.ageBirthMax = data
            this.submitData()
        },
        submitData() {
            // console.log('submit data', this.matchGroup)
            this.$emit('custom-event', {
                type: 'submit',
                data: this.matchGroup
            })
        },
    },
}
</script>

<template>
    <div class="match-signup-contestant-config-edit">
        <div class="nav-op-bar fixed-top">
            <van-row class="hp100 vertical-center">
                <van-col 
                    class="main-text primary-color text-right u-inner-padding" 
                    span="24"
                    @click="onSaveBtnClick">
                    {{ locale['confirm'] }}
                </van-col>
            </van-row>
        </div>
        <numeric-range-selector
            :label="locale['team-number']"
            :unit="locale['person']"
            :min="Number(matchGroup.numSelection)"
            :down="matchGroup.teamNumMin"
            :up="matchGroup.teamNumMax"
            @change-data="onTeamNumDataChange"
        />
        <picker-selector
            :label="locale['gener-restriction']"
            :options="genderRestrictionOptions"
            :value="matchGroup.genderRestriction"
            @change-data="onGenderRestrictionDataChange"
        />
        <numeric-range-selector
            v-if="isGenderNumShow"
            :label="locale['male-member-number']"
            :unit="locale['person']"
            :max="matchGroup.teamNumMax"
            :down="matchGroup.maleNumMin"
            :up="matchGroup.maleNumMax || matchGroup.teamNumMax"
            @change-data="onMaleNumDataChange"
        />
        <numeric-range-selector
            v-if="isGenderNumShow"
            :label="locale['female-member-number']"
            :unit="locale['person']"
            :max="matchGroup.teamNumMax"
            :down="matchGroup.femaleNumMin"
            :up="matchGroup.femaleNumMax || matchGroup.teamNumMax"
            @change-data="onFemaleNumDataChange"
        />
        <div class="u-outer-padding">
            <span class="minor-text minor-color">{{ locale['age-restriction'] }}</span>
        </div>
        <date-selector
            :label="locale['birth-earliest-date']"
            :placeholder="locale['no-limit']"
            :clearable="true"
            :value="matchGroup.ageBirthMin"
            :min-date="minDateField"
            :max-date="maxDateField"
            @change-data="onAgeRestrictionMinDateChange"
        />
        <date-selector
            :label="locale['birth-latest-date']"
            :placeholder="locale['no-limit']"
            :clearable="true"
            :value="matchGroup.ageBirthMax"
            :min-date="matchGroup.ageBirthMin || minDateField"
            :max-date="maxDateField"
            @change-data="onAgeRestrictionMaxDateChange"
        />
    </div>
</template>